import { Button } from '@mui/material';
import React from 'react'
import FontAwesome from 'react-fontawesome';
import { Link } from 'react-router-dom'


export function IstError(props) {
    const message = props.message || '';
    const buttonLabel = props.button_label || '戻る';

    return (
        <div className='error__wrapper'>
          <FontAwesome 
           name='fa fa-exclamation-triangle' 
           size='3x' 
           style={{ textShadow: '0 1px 0 rgba(0, 0, 0, 0.1)' }} 
          />
          <h3 className="form-confirm-heading">エラーが発生しました</h3>
          <div>
              <h5>{message}</h5>
          </div>
          <div className="flex-box-horizontal-nowrap">
              <div 
               className="button_wrapper flex-col-auto" 
               onClick={() => { document.location.href = '/do/menu' }}
              >
                <button className="button">{buttonLabel}</button>
              </div>
          </div>
        </div>
    );
}

export function IstError404(props) {
    const message = props.message || '該当するページが見つかりませんでした';
    const buttonLabel = props.button_label || '戻る';
  
    return (
      <div id="default_message">
        <div id="Main">
          <div className="lead">{message}</div>
          <Button
           variant="outlined"
           onClick={() => { document.location.href = '/' }}
          >
            <Link to="/category">{buttonLabel}</Link>
          </Button>
        </div>
      </div>
    );
}
  
